<template>
  <div class="SummaryList" :class="[mode]">
    <div class="SummaryContainer" :class="[mode]">
      <div
        v-for="item in items"
        :key="item.inventory_product_id"
        class="SummaryWrapper"
      >
        <Summary
          class="Summary"
          :class="itemClassName"
          :data="item"
          :disable-view-transition="shouldDisableViewTransition"
        />
      </div>
    </div>

    <template v-if="showReadMore">
      <TextLink v-if="readMoreType === 'link'" :to="readMoreLink" :text="readMoreLabel" />
      <TextButton v-else-if="readMoreType === 'button'" :text="readMoreLabel" @click="$emit('readMore')"/>
    </template>
  </div>
</template>

<script lang="ts">
import { defineNuxtComponent } from '#app'
import type { ESPokemonSingleProduct } from '@ka-nabellinc/tcg-platform-es-schema'
import { TextLink, TextButton } from '@ka-nabellinc/ka-nabell-ui'
import { computed } from 'vue'
import Summary from '@/components/Pokemon/Single/Summary'

export default defineNuxtComponent({
  components: {
    Summary,
    TextLink,
    TextButton,
  },
  props: {
    items: {
      type: Array as () => ESPokemonSingleProduct[],
      default: []
    },
    showReadMore: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String as () => 'vertial' | 'horizontal',
      default: 'vertical'
    },
    readMoreLink: {
      type: String
    },
    disableViewTransition: {
      type: Boolean,
      default: false
    },
    readMoreLabel: {
      type: String,
      default: 'さらに表示'
    },
    itemClassName: {
      type: String,
    }
  },
  emits: ['readMore'],
  setup(props) {
    // 水平スクロール時は挙動が不安定になるためview transisionをoffにする
    const shouldDisableViewTransition = computed(() => props.disableViewTransition || props.mode === 'horizontal')

    const readMoreType = computed<'button' | 'link'>(() => 
      typeof props.readMoreLink === 'string' && props.readMoreLink ? 'link' : 'button'
    )

    return {
      shouldDisableViewTransition,
      readMoreType,
    }
  }
})
</script>

<style scoped>
.SummaryList {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  overflow: hidden;
}

.SummaryContainer {
  width: 100%;
  display: flex;
  column-gap: 12px;
  row-gap: 20px;
  flex-wrap: wrap;
}

.SummaryContainer.horizontal {
  flex-wrap: nowrap;
  overflow-x: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
  padding-left: 16px;
  padding-right: 16px;
  gap: 12px;
}

.SummaryContainer.horizontal::-webkit-scrollbar {
  display: none;
}

.SummaryWrapper {
  width: calc((100% - (12px * 2)) / 3);
}

.SummaryContainer.horizontal .SummaryWrapper {
  flex: 0 0 calc((100% - 24px) / 3);
}


.SummaryContainer.horizontal .SummaryWrapper:last-child {
  margin-right: 0;
}
</style>
